"use client"

import { useState } from "react"
import TurmaForm from "../components/Turmas/TurmaForm"
import TurmaList from "../components/Turmas/TurmaList"
import "../styles/TurmasPage.css"

export default function TurmasPage() {
  const [updateList, setUpdateList] = useState(false)
  const [turmaParaEditar, setTurmaParaEditar] = useState(null)

  const handleAdded = () => {
    setUpdateList((prev) => !prev)
    setTurmaParaEditar(null)
  }

  const handleEdit = (turma) => {
    setTurmaParaEditar(turma)
    // Scroll para o formulário
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleCancelEdit = () => {
    setTurmaParaEditar(null)
  }

  return (
    <div className="turmas-page">
      <h1 className="page-title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        Gestão de Turmas
      </h1>

      <TurmaForm onAdded={handleAdded} turmaParaEditar={turmaParaEditar} onCancelEdit={handleCancelEdit} />

      <TurmaList keyProp={updateList} onEdit={handleEdit} />
    </div>
  )
}
